import * as React from 'react'

import { StyledForm } from './Form.glamorous'

export const Form: React.SFC<React.FormHTMLAttributes<HTMLFormElement>> = (props) => {
  return <StyledForm {...props} />
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/ForgotForm/components/Form/Form.tsx